import { Permission, alphabeticalSort } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditRfiResponseDisciplineMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIResponseDiscipline,
  useResponseDisciplinesTableContext,
} from '../../../../ResponseDisciplinesTableContext'
import {
  EditResponseDisciplineModalBody,
  EditResponseDisciplineModalValues,
} from './components/EditResponseDisciplineModalBody'
import { useUserSelectContext } from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { notEqual } from '@cims-online/shared'

export function useEditOptions(): EditRowActionOptions<
  RFIResponseDiscipline,
  EditResponseDisciplineModalValues
> {
  const { refetch } = useResponseDisciplinesTableContext()
  const { toLabeledValues, fromLabeledValues } = useUserSelectContext()
  const [editResponseDiscipline] = useEditRfiResponseDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editRFIResponseDiscipline: {
        responseDiscipline: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditRFIResponseDiscipline,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <EditResponseDisciplineModalBody />,
      initialValues: ({ name, description, users }) => {
        return {
          name,
          description,
          responders: toLabeledValues(users).sort(alphabeticalSort('label')),
        }
      },
      onOk: async (
        { id, name: prevName, description: prevDescription, users: prevUsers },
        { name, description, responders }
      ) => {
        const prevUserIds = prevUsers.map(({ id }) => id)
        const userIds = fromLabeledValues(responders)
        if (
          prevName !== name ||
          prevDescription !== description ||
          notEqual(prevUserIds, userIds)
        ) {
          await editResponseDiscipline({
            variables: {
              editRfiResponseDisciplineInput: {
                id,
                name,
                description,
                userIds,
              },
            },
          })
          await refetch()
        }
      },
    },
  }
}
